import { useCallback, useRef } from 'react';

type CallbackFunction<T> = (args: T) => void;

export const useDebouncedCallback = <T>(callback?: CallbackFunction<T>, delay: number = 300): CallbackFunction<T> | undefined => {
    const timeoutRef = useRef<number | null>(null);

    const debouncedCallback: CallbackFunction<T> = useCallback(
        (args: T) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = window.setTimeout(() => {
                if (callback) callback(args);
            }, delay);
        },
        [callback, delay]
    );

    return callback ? debouncedCallback : undefined;
};
